const languages = {
	ru: {
		label: "ru",
		i18n: "russian",
	},
	uzCyrl: {
		label: "uz_cyrl",
		i18n: "uzbek_cyrl",
	},
	uzLatn: {
		label: "uz_latn",
		i18n: "uzbek_latn",
	},
	tr: {
		label: "tr",
		i18n: "turkish",
	},
}

export default languages
